/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Provider_MetaInputs */

const cs_integrations_provider_meta = /** @type {(inputs: Integrations_Provider_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta`)
};

const en_integrations_provider_meta = /** @type {(inputs: Integrations_Provider_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta`)
};

/**
* | output |
* | --- |
* | "Meta" |
*
* @param {Integrations_Provider_MetaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_provider_meta = /** @type {((inputs?: Integrations_Provider_MetaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Provider_MetaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_provider_meta(inputs)
	return cs_integrations_provider_meta(inputs)
});